import _noop from "lodash/noop";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RawMouseEvent = window.MouseEvent; // if ts compile target is es5, the native super/extends has some problems
// see: https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work

var FakeMouseEvent = /*#__PURE__*/function (_RawMouseEvent) {
  _inherits(FakeMouseEvent, _RawMouseEvent);

  var _super = _createSuper(FakeMouseEvent);

  function FakeMouseEvent(typeArg, mouseEventInit) {
    _classCallCheck(this, FakeMouseEvent);

    var _a; // if UIEvent want to window view, we should replace ProxyWindow with Window


    if (mouseEventInit && ((_a = mouseEventInit.view) === null || _a === void 0 ? void 0 : _a.top) === mouseEventInit.view) {
      // resolve: https://github.com/umijs/qiankun/issues/570
      // eg: https://github.com/apache/incubator-echarts/blob/master/src/component/toolbox/feature/SaveAsImage.js#L63...L75
      mouseEventInit.view = window;
    }

    return _super.call(this, typeArg, mouseEventInit);
  }

  return FakeMouseEvent;
}(RawMouseEvent);

export default function patch(global) {
  global.MouseEvent = FakeMouseEvent;
  return function free() {
    global.MouseEvent = RawMouseEvent;
    return _noop;
  };
}